module.exports = __webpack_public_path__ + "static/img/img-exact.ceaf98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c30/img-exact.png
// module id = jII3
// module chunks = 0